import React from "react";

const Row = ({ k, v }) => (v ? <div className="text-sm"><span className="text-xs" style={{ color: "var(--sj-text-3)" }}>{k}: </span>{v}</div> : null);

export const MemberSelfReported = ({ m }) => {
  const emergency = [m.emergency_name, m.emergency_relationship && `(${m.emergency_relationship})`, m.emergency_phone].filter(Boolean).join(" ");
  const prefs = [m.sms_opt_in === false && "No texts", m.email_opt_in === false && "No emails"].filter(Boolean).join(" · ");
  if (!emergency && !m.marital_status && !m.occupation && !prefs) return null;
  return (
    <div className="sm:col-span-2 rounded-xl border p-3 flex gap-3" style={{ borderColor: "var(--sj-border)", background: "#FBFAF7" }} data-testid="member-self-reported">
      <div className="min-w-0 space-y-0.5">
        <div className="text-xs font-semibold" style={{ color: "var(--sj-primary)" }}>Updated by the member</div>
        <Row k="Marital status" v={m.marital_status} />
        <Row k="Occupation" v={m.occupation} />
        <Row k="Emergency contact" v={emergency} />
        {prefs && <div className="text-sm font-semibold" style={{ color: "#B45309" }} data-testid="member-contact-prefs">Contact preference: {prefs}</div>}
      </div>
    </div>
  );
};
